<template>
  <div>
    <aside class="admin-sidebar">
      <div class="admin-brand-lockup">
        <span class="admin-brand-mark">YL</span>
        <div><strong>{{$siteOptions.brandName}}</strong><small>Delegated Admin</small></div>
      </div>
      <nav>
        <router-link to="/dashboard"><span>⌂</span>Overview</router-link>
        <router-link to="/templates"><span>◇</span>Templates</router-link>
        <router-link to="/sites"><span>◫</span>Sites</router-link>
        <router-link to="/builds-deployments"><span>⇄</span>Builds & deployments</router-link>
        <router-link to="/domains"><span>◎</span>Domains</router-link>
        <router-link v-if="canReadData" to="/cms"><span>▤</span>Content</router-link>
        <router-link v-if="canUpdateData" to="/data-updates"><span>↻</span>Data updates</router-link>
        <router-link v-if="$siteOptions.showAudit" to="/audit-users"><span>≡</span>Audit & users</router-link>
      </nav>
      <div class="admin-sidebar-foot">
        <span class="admin-online-dot"></span>
        <div><strong>Platform contract 1.0</strong><small>Authorized branch control</small></div>
      </div>
    </aside>
    <header class="admin-topbar">
      <div><span class="admin-kicker">Managed Admin branch</span><h1>{{pageTitle}}</h1></div>
      <div class="admin-identity">
        <select :value="session.root?.site_id" aria-label="Active managed root" @change="switchRoot($event.target.value)">
          <option v-for="item in session.assignments" :key="item.site_id" :value="item.site_id">{{item.site_name}} · {{item.role}}</option>
        </select>
        <span class="admin-avatar">{{initials}}</span>
        <small>{{session.user?.email}}</small>
        <button @click="exit">Sign out</button>
      </div>
    </header>
  </div>
</template>
<script>import{session,selectRoot,signOut,can}from'../platform/session';export default{name:'Navigation',computed:{session:()=>session,canReadData:()=>can('data:read'),canUpdateData:()=>can('data:update'),initials(){return(this.session.user?.email||'AD').slice(0,2).toUpperCase()},pageTitle(){return this.$route.path.split('/').filter(Boolean).pop()||'Overview'}},methods:{switchRoot(id){selectRoot(id);if(this.$route.path==='/dashboard')this.$router.go(0);else this.$router.push('/dashboard')},async exit(){await signOut();this.$router.replace('/')}}}</script>
